import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {SubTypeProductService} from "../../../services/sub-type-product.service";
import {TypeProductService} from "../../../services/type-product.service";
import {first} from "rxjs/operators";

@Component({
  selector: 'app-brand-sub-type-product-add-edit',
  templateUrl: './brand-sub-type-product-add-edit.component.html',
  styleUrls: ['./brand-sub-type-product-add-edit.component.scss']
})
export class BrandSubTypeProductAddEditComponent implements OnInit {

    form: FormGroup;
    submitted = false;
    loading = false;
    id: number;
    update = false;
    sub_type_product: any = [];
    type_products: any = [];
    select_type_product: any;
    type_product_data: any = [];

    constructor(
        private formBuilder: FormBuilder,
        private toastrService: ToastrService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private subTypeProductService: SubTypeProductService,
        private typeProductService: TypeProductService,
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            type_product_id: null,
            type_products: null,
        });

        this.id = this.activatedRoute.snapshot.params['id'];

        if (this.id) {
            this.update = true;
            this.subTypeProductService.getById(this.id).subscribe(response => {
                this.form.patchValue(response.data);
                response.type_product.forEach((data, index) => {
                    if (data.type_product) {
                        this.type_product_data.push(data.type_product);
                    }
                })
                this.sub_type_product = response.data;
            }, error => {
                this.router.navigate(['/brand-sub-type-products']);
            });
        }

        this.getTypeProducts();
    }

    onSelectTypeProduct(e) {
        this.select_type_product = e.target.value;
    }

    addTypeProduct() {
        if (this.select_type_product) {
            this.type_products.forEach(item => {
                if (item.id == this.select_type_product) {
                    let duplicate = this.type_product_data.filter(data => data.id == this.select_type_product);
                    if (duplicate.length < 1) {
                        this.type_product_data.push(item);
                    }
                }
            });
        }
    }

    deleteTypeProduct(item: any){
        this.type_product_data.forEach((data, index) => {
            if (data.id == item) {
                this.type_product_data.splice(index, 1);
            }
        })
    }

    get f() {
        return this.form.controls;
    }

    getTypeProducts() {
        this.typeProductService.getAll().subscribe(response => {
            this.type_products = response.data;
        }, error => {
            this.toastrService.error(error, 'Error');
        });
    }

    sendForm(): void {
        this.submitted = true;
        if (!this.form.valid) {
            return;
        }
        if (this.type_product_data.length == 0) {
            this.toastrService.error( 'Agrege un tipo de producto!');
            return;
        }
        this.form.controls.type_products.setValue(this.type_product_data);
        let item = Object.assign({}, this.form.value);

        if (this.update) {
            item.id = this.id;
            this.subTypeProductService.update(item)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/brand-sub-type-products']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        } else {
            this.subTypeProductService.store(item)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/brand-sub-type-products']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        }
    }
}
